import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'

import { ApiService } from '@shared/services/api.service'
import { Permission } from '@shared/models/permission.model'
import { PermissionSourceType } from '@core/types/permissions.source'
// TODO: move to app/core/services
@Injectable({ providedIn: 'root' })
export class PermissionsService {
  private readonly currentUserPermissions = new BehaviorSubject<Permission[]>(null)
  readonly currentUserPermissions$ = this.currentUserPermissions.asObservable()

  constructor(private apiService: ApiService) {}

  setPermissions(data: Permission[]): void {
    this.currentUserPermissions.next(data)
  }

  getPermissions(): Observable<string[]> {
    return this.apiService.get('/permissions/current-plan')
  }

  hasPermissionAsync(permissionType: PermissionSourceType): Observable<boolean> {
    const toBoolean = (permissions: Permission[] | null) => !!permissions && permissions.some(({ name }) => name === permissionType)

    return this.currentUserPermissions$.pipe(first(), map(toBoolean))
  }

  hasPermissionSync(permissionType: PermissionSourceType): boolean {
    const permission = ({ name }: Permission) => name === permissionType
    return !!this.currentUserPermissions.getValue()?.find(permission)
  }

  hasAnyPermission(): boolean {
    const perms = this.currentUserPermissions.getValue()
    return Array.isArray(perms) && perms.length > 0
  }

  purge(): void {
    this.setPermissions(null)
  }
}
